<form (ngSubmit)="onSubmit()">
    <div class="row mb-3">
        <div class="col-md-4">
            <div class="mt-2">
                <label>{{'_Data_Import_File_Type_Select_Label_Text_' | translate }}</label>
                <select class="cc-select-dropdown form-control" [(ngModel)]="fileTypeSelected" name="file-type-select">
                    <option *ngFor="let fileObject of selectableEntities" [ngValue]="fileObject.id" #selectFileType>
                        {{fileObject.name | translate}}
                    </option>
                </select>
            </div>
        </div>
        <div class="col-md-4">
            <div class="form-group mt-4">
                <kendo-fileselect [multiple]="false" (select)="handleFileInput($event)" [restrictions]="restrictions"
                    [disabled]="fileTypeSelected == 0">
                    <kendo-fileselect-messages select="{{'_Data_Import_Select_File_Button_Text_' | translate }}" dropFilesHere="{{'_Data_Import_Drag_And_Drop_File_Text_' | translate }}" invalidFileExtension="{{'_Data_Import_File_Type_Not_Allow_Text_' | translate}}" remove="{{'_User_Availability_Template_Remove_Button_Text_' | translate}}">
                    </kendo-fileselect-messages>
                </kendo-fileselect>
            </div>
        </div>
        <div class="col-md-4">
            <div class="ms-md-4 mb-2 mt-md-4">
                <button [disabled]="submitted || !fileData || invalidFile" class="btn btn-primary mt-md-1">{{'_Data_Import_Submit_File_Button_Text_' | translate }}</button>
            </div>
        </div>
    </div>
</form>